export default __webpack_public_path__ + "static/media/parallax-bg34.d2b4360c.jpg";